import { render, staticRenderFns } from "./editpassword.vue?vue&type=template&id=790a005e&scoped=true&"
import script from "./editpassword.vue?vue&type=script&lang=js&"
export * from "./editpassword.vue?vue&type=script&lang=js&"
import style0 from "./editpassword.vue?vue&type=style&index=0&id=790a005e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a005e",
  null
  
)

export default component.exports